import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsAnItineraryResultPage } from '../../../store/history/history.selectors'
import { setStepFromAddress } from '../../../store/itinerary/itinerary.actions'
import { addStep, setStepIdx } from '../../../store/itinerary/itinerarySlice'
import { selectLocale } from '../../../store/navigation/navigation.selectors'
import { useT } from '../../i18n/T'
import { selectStepsLength } from '../../itinerary/steps/steps.selectors'
import { useAction, withEverySelectorTruthy } from '../../utils/react-redux'
import ContextMenuItem from './ContextMenuItem'
import { AJOUTER_ETAPE } from './contextmenu.constants'
import { findAddressFromPoint } from './contextmenu.utils'

const ContextMenuItemItineraryAddStep = () => {
  const label = useT('map.context-menu.add-step-itinerary')
  const dispatch = useDispatch()
  const execSetStepFromAddress = useAction(setStepFromAddress)
  const stepsLength = useSelector(selectStepsLength)
  const locale = useSelector(selectLocale)

  const onAddStep = point => {
    findAddressFromPoint({ ...point, locale })
      .then(address => {
        dispatch(addStep())
        dispatch(setStepIdx(stepsLength - 1))
        execSetStepFromAddress(address)
      })
      .catch(e => console.error(e))
  }

  return <ContextMenuItem tagAction={AJOUTER_ETAPE} label={label} clickAction={onAddStep} />
}

export default withEverySelectorTruthy(selectIsAnItineraryResultPage)(ContextMenuItemItineraryAddStep)
